import React from "react";

// Admin Imports
import MainDashboard from "views/admin/default";
import NFTMarketplace from "views/admin/marketplace";
import Profile from "views/admin/profile";
import DataTables from "views/admin/tables";
import RTLDefault from "views/rtl/default";
import Professionals from "views/admin/professionals";
import Patients from "views/admin/patients";
import PatientDetail from "views/admin/patients/PatientDetail";
import QuestionnaireResult from "views/admin/patients/QuestionnaireResult";
import QuestionnairesList from "views/admin/questionnaires";
import QuestionnaireDetail from "views/admin/questionnaires/QuestionnairesDetail";
import Evaluaciones from "views/admin/evaluaciones";
import Clientes from "views/admin/clientes";
import InformeDetalle from "views/admin/evaluaciones/InformeDetalle";

// Questionnaire Imports
import QuestionnaireLanding from "views/questionnaires/QuestionnaireLanding";
import QuestionnaireResponse from "views/questionnaires/QuestionnaireResponse";
import EvaluacionLanding from "views/evaluacion/EvaluacionLanding";

// Auth Imports
import SignIn from "views/auth/SignIn";

// Icon Imports
import {
  MdHome,
  MdOutlineShoppingCart,
  MdBarChart,
  MdPerson,
  MdLock,
  MdPeople,
  MdPersonOutline,
  MdAssignment,
} from "react-icons/md";

// Component Imports
import ProtectedRoute from "components/auth/ProtectedRoute";
import { UserRole } from "types/auth";
import ReportDetail from "views/admin/reports/ReportDetail";

export interface Route {
  name: string;
  layout: string;
  path: string;
  icon: JSX.Element;
  component: JSX.Element;
  secondary?: boolean;
  roles?: UserRole[];
  hidden?: boolean;
}

const routes: Route[] = [
  {
    name: "Main Dashboard",
    layout: "/admin",
    path: "default",
    icon: <MdHome className="h-6 w-6" />,
    component: (
      <ProtectedRoute>
        <MainDashboard />
      </ProtectedRoute>
    ),
  },
  {
    name: "Profesionales",
    layout: "/admin",
    path: "professionals",
    icon: <MdPeople className="h-6 w-6" />,
    component: (
      <ProtectedRoute roles={["admin"]}>
        <Professionals />
      </ProtectedRoute>
    ),
    roles: ["admin"],
  },
  {
    name: "Pacientes",
    layout: "/admin",
    path: "patients",
    icon: <MdPersonOutline className="h-6 w-6" />,
    component: (
      <ProtectedRoute roles={["admin", "psychologist"]}>
        <Patients />
      </ProtectedRoute>
    ),
    roles: ["admin", "psychologist"],
  },
  {
    name: "Cuestionarios",
    layout: "/admin",
    path: "questionnaires",
    icon: <MdAssignment className="h-6 w-6" />,
    component: (
      <ProtectedRoute roles={["admin", "psychologist"]}>
        <QuestionnairesList />
      </ProtectedRoute>
    ),
    roles: ["admin", "psychologist"],
  },
  {
    name: "Evaluaciones",
    layout: "/admin",
    path: "evaluaciones",
    icon: <MdAssignment className="h-6 w-6" />,
    component: (
      <ProtectedRoute roles={["admin", "psychologist"]}>
        <Evaluaciones />
      </ProtectedRoute>
    ),
    roles: ["admin", "psychologist"],
  },
  {
    name: "Clientes",
    layout: "/admin",
    path: "clientes",
    icon: <MdPeople className="h-6 w-6" />,
    component: (
      <ProtectedRoute roles={["admin", "psychologist"]}>
        <Clientes />
      </ProtectedRoute>
    ),
    roles: ["admin", "psychologist"],
  },
  {
    name: "Informe de Evaluación",
    layout: "/admin",
    path: "evaluaciones/:sessionId",
    icon: <MdAssignment className="h-6 w-6" />,
    component: (
      <ProtectedRoute roles={["admin", "psychologist"]}>
        <InformeDetalle />
      </ProtectedRoute>
    ),
    roles: ["admin", "psychologist"],
    hidden: true,
  },
  {
    name: "Detalle de Cuestionario",
    layout: "/admin",
    path: "questionnaires/:id",
    icon: <MdAssignment className="h-6 w-6" />,
    component: (
      <ProtectedRoute roles={["admin", "psychologist"]}>
        <QuestionnaireDetail />
      </ProtectedRoute>
    ),
    roles: ["admin", "psychologist"],
    hidden: true,
  },
  {
    name: "Detalle de Paciente",
    layout: "/admin",
    path: "patients/:id",
    icon: <MdPersonOutline className="h-6 w-6" />,
    component: (
      <ProtectedRoute roles={["admin", "psychologist"]}>
        <PatientDetail />
      </ProtectedRoute>
    ),
    roles: ["admin", "psychologist"],
    hidden: true,
  },
  {
    name: "Reportes",
    layout: "/admin",
    path: "reports/:id",
    icon: <MdBarChart className="h-6 w-6" />,
    component: <ReportDetail />,
  },
  {
    name: "Resultados del Cuestionario",
    layout: "/admin",
    path: "questionnaire-results/:detailId",
    icon: <MdBarChart className="h-6 w-6" />,
    component: (
      <ProtectedRoute roles={["admin", "psychologist"]}>
        <QuestionnaireResult />
      </ProtectedRoute>
    ),
    roles: ["admin", "psychologist"],
    hidden: true,
  },
  {
    name: "Sign In",
    layout: "/auth",
    path: "sign-in",
    icon: <MdLock className="h-6 w-6" />,
    component: <SignIn />,
    hidden: true,
  },
  // Public route for questionnaires (no authentication required)
  {
    name: "Cuestionarios",
    layout: "/questionnaires",
    path: "",
    icon: <MdBarChart className="h-6 w-6" />,
    component: <QuestionnaireLanding />,
    hidden: true,
  },
  // Public route for questionnaire response (no authentication required)
  {
    name: "Responder Cuestionario",
    layout: "/questionnaires",
    path: "respond",
    icon: <MdBarChart className="h-6 w-6" />,
    component: <QuestionnaireResponse />,
    hidden: true,
  },
  // Public route for self-service skills evaluation (Reskilling)
  {
    name: "Evaluación de habilidades",
    layout: "/evaluacion",
    path: "",
    icon: <MdBarChart className="h-6 w-6" />,
    component: <EvaluacionLanding />,
    hidden: true,
  },
];

export default routes;
